import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../shared/services';
import { InspectionPlugin } from '../../shared/models/index';

@Injectable()
export class AssistancePluginService extends InspectionPluginService {
  private actionKeys = [
    { value: 1, label: 'plugins.assistance.required' },
    { value: 2, label: 'plugins.assistance.advised' }
  ];

  private actionOptions = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  getActionOptions() {
    return this.actionOptions;
  }

  public updateAssistances(inspectionId: string, pointId: string, pluginId: string, assistances: any[]): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, assistances).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private applyTranslations() {
    this.actionOptions = [];
    this.copyTranslationValues(this.actionKeys, this.actionOptions, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, assistances: any[]): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, assistances, 'Assistances').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
